import { ScenarioDiagram } from 'routes/Scenarios/Scenario/components/ScenarioDiagram'
import { ScenarioTemplateExtended } from 'routes/Scenarios/helpers/types'
import { IntegrationElementType, ScenarioElement } from '@integration-app/sdk'

export function ScenarioGraph({
  scenario,
}: {
  scenario: ScenarioTemplateExtended
}) {
  const elements: ScenarioElement[] = (scenario.handyElements ?? [])
    .filter(
      (e) =>
        e.type === IntegrationElementType.ACTION ||
        e.type === IntegrationElementType.FLOW,
    )
    .map((e) => {
      return {
        id: e.fields.key + (e.integration?.key ?? ''),
        type: e.type,
        element: e.fields,
      }
    })

  return (
    <ScenarioDiagram connectors={scenario.connectors} elements={elements} />
  )
}
